import { render, staticRenderFns } from "./CreateCompanyWfhDayModal.vue?vue&type=template&id=588c00e1&"
import script from "./CreateCompanyWfhDayModal.vue?vue&type=script&lang=js&"
export * from "./CreateCompanyWfhDayModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports